/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

angular.module('common.filter.decimalNumberExchangeRateResult', ['common.config']).filter('decimalNumberExchangeRateResult', function(CONSTANTS){
    return function(number) {
        if (isNaN((number))){
            return null;
        }
        return accounting.formatNumber(number, CONSTANTS.numberFractionExchangeRateResult, CONSTANTS.thousandsSeparator, CONSTANTS.decimalSeparator);
  };
});



// WEBPACK FOOTER //
// ./app/common/filter/decimal-number-exchangerates-result-filter.js